// Replace with your Google Cloud OAuth Client ID
// See SETUP.md for instructions
export const CLIENT_ID = '548805259852-0112i12d55t6jms75mv3o6u0dla5eiug.apps.googleusercontent.com';

export const SCOPES = [
  'openid',
  'https://www.googleapis.com/auth/userinfo.profile',
  'https://www.googleapis.com/auth/userinfo.email',
  'https://www.googleapis.com/auth/gmail.modify',
  'https://www.googleapis.com/auth/calendar',          // write + read (was: .readonly)
  'https://www.googleapis.com/auth/drive.file',        // create/edit files Harmonee creates
  'https://www.googleapis.com/auth/drive.readonly',    // read all (keep for browsing)
  'https://www.googleapis.com/auth/documents',         // write into Docs
  'https://www.googleapis.com/auth/tasks',
  'https://www.googleapis.com/auth/spreadsheets.readonly',
].join(' ');

export const DISCOVERY_DOCS = [
  'https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest',
  'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest',
  'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest',
  'https://www.googleapis.com/discovery/v1/apis/tasks/v1/rest',
  'https://www.googleapis.com/discovery/v1/apis/sheets/v4/rest',
];
